import React from 'react';

const Error = (props) => {
    const {
        message = 'An error occurred.',
    } = props;

    const renderSingleMessage = () => {
        return (
            <span>{message}</span>
        )
    }

    const renderMultipleMessages = () => {
        return (
            <ul>
                {message.map((text, index) => (
                    <li key={index}>{text}</li>
                ))}
            </ul>
        );
    }

    const renderMessages = () => {
        if (Array.isArray(message)) {
            return renderMultipleMessages();
        }

        return renderSingleMessage();
    }

    return (
        <div className={"error-container"}>
            {renderMessages()}
        </div>
    );
}

export default Error;
